import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/additional-prams-icon.svg'


const _hoisted_1 = { id: "global-setting" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Pengaturan Global")
  ])
], -1)
const _hoisted_3 = { class: "mx-5 mb-5 text-lg" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-8 mx-5 bottom-separator" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "p-inputgroup w-full mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_11 = {
  key: 1,
  class: "p-inputgroup-addon"
}
const _hoisted_12 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_13 = {
  key: 1,
  class: "p-input-icon-right w-full mt-1"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage" }, null, -1)
const _hoisted_15 = {
  key: 2,
  class: "p-input-icon-right w-full mt-1"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "pi pi-globe" }, null, -1)
const _hoisted_17 = { class: "p-field-radiobutton" }
const _hoisted_18 = { class: "p-field-radiobutton" }
const _hoisted_19 = {
  key: 7,
  class: "card-voucher-discount bg-white"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "header-card" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_23 = { class: "content-card mt-5" }
const _hoisted_24 = { class: "w-full items-center mb-2" }
const _hoisted_25 = { class: "text-black font-semibold hover-primary break-all" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "header-card" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "w-full container-add-prams background-grey-lighten-5 p-5 cursor-pointer" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-center mb-2" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "",
      alt: "ads"
    })
  ]),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold text-center text-sm leading-5" }, " No image ... ")
], -1)
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "header-card" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_32 = { class: "content-card mt-5" }
const _hoisted_33 = { class: "w-full items-center mb-2" }
const _hoisted_34 = { class: "text-black font-semibold hover-primary break-all" }
const _hoisted_35 = { class: "action-button mt-10 mx-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.dataset, (items) => {
          return (_openBlock(), _createBlock("div", {
            class: "mb-10",
            key: items[0]
          }, [
            _createVNode("p", _hoisted_3, _toDisplayString(items[2]), 1),
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items[1], (item) => {
                return (_openBlock(), _createBlock("div", {
                  class: "p-field",
                  key: item.Id
                }, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("label", {
                      for: item.Code,
                      class: "mr-2"
                    }, _toDisplayString(item.Name), 9, ["for"]),
                    _withDirectives(_createVNode("span", _hoisted_6, [
                      _hoisted_7
                    ], 512), [
                      [_directive_tooltip, item.Description]
                    ])
                  ]),
                  (item.Type == 'NUM')
                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                        (item.Code == 'ToleransiKeberangkatan' || item.Code == 'ToleransiOrderKurir'  || item.Code == 'RadiusPenjemputan' || item.Code == 'JamKerjaKurir' || item.Code == 'MaxBatasPembayaranDeposit' || item.Code === 'ToleransiPembatalanPengiriman' || item.Code === 'MaxBatasGagalBayar' || item.Code == 'HukumanTidakBisaBuatOrder')
                          ? (_openBlock(), _createBlock("div", _hoisted_9, [
                              _createVNode(_component_InputText, {
                                type: "number",
                                class: "input-primary rounded-lg w-full",
                                disabled: !$setup.route.meta.permission.write,
                                id: item.Code,
                                modelValue: item.Value,
                                "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                                placeholder: item.Description
                              }, null, 8, ["disabled", "id", "modelValue", "onUpdate:modelValue", "placeholder"]),
                              (item.Code == 'RadiusPenjemputan')
                                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString('KM')))
                                : _createCommentVNode("", true),
                              (item.Code == 'JamKerjaKurir' || item.Code === 'MaxBatasPembayaranDeposit' || item.Code === 'ToleransiPembatalanPengiriman' || item.Code === 'MaxBatasGagalBayar' || item.Code == 'HukumanTidakBisaBuatOrder')
                                ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString('Jam')))
                                : _createCommentVNode("", true),
                              (item.Code == 'ToleransiKeberangkatan')
                                ? (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString('Menit')))
                                : _createCommentVNode("", true)
                            ]))
                          : (item.Code == 'MaxDiskonPelanggan')
                            ? (_openBlock(), _createBlock("span", _hoisted_13, [
                                _hoisted_14,
                                _createVNode(_component_InputText, {
                                  type: "number",
                                  disabled: !$setup.route.meta.permission.write,
                                  class: "input-primary rounded-lg w-full",
                                  id: item.Code,
                                  modelValue: item.Value,
                                  "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                                  placeholder: item.Description,
                                  max: "100",
                                  onChange: $setup.ValMaxPersen
                                }, null, 8, ["disabled", "id", "modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                              ]))
                            : (item.Code == 'AdminWhatsappNumber')
                              ? (_openBlock(), _createBlock(_component_InputText, {
                                  key: 2,
                                  type: "tel",
                                  disabled: !$setup.route.meta.permission.write,
                                  class: "input-primary rounded-lg w-full",
                                  id: item.Code,
                                  modelValue: $setup.v$.whatsapp.$model,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.whatsapp.$model = $event))
                                }, null, 8, ["disabled", "id", "modelValue"]))
                              : (_openBlock(), _createBlock(_component_InputNumber, {
                                  key: 3,
                                  class: "input-primary rounded-lg w-full mt-1",
                                  disabled: !$setup.route.meta.permission.write,
                                  id: item.Code,
                                  modelValue: item.Value,
                                  "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                                  showButtons: "",
                                  buttonLayout: "horizontal",
                                  incrementButtonIcon: "pi pi-plus",
                                  decrementButtonIcon: "pi pi-minus",
                                  min: 0,
                                  placeholder: item.Description
                                }, null, 8, ["disabled", "id", "modelValue", "onUpdate:modelValue", "placeholder"]))
                      ]))
                    : (item.Type == 'STRA' || item.Type == 'STR')
                      ? (_openBlock(), _createBlock(_component_Textarea, {
                          key: 1,
                          placeholder: item.Description,
                          class: "input-primary w-full rounded-lg mt-1",
                          modelValue: item.Value,
                          "onUpdate:modelValue": ($event: any) => (item.Value = $event)
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]))
                      : (item.Code == 'UrlForgotPassword')
                        ? (_openBlock(), _createBlock("span", _hoisted_15, [
                            _hoisted_16,
                            _createVNode(_component_InputText, {
                              type: "text",
                              disabled: !$setup.route.meta.permission.write,
                              class: "input-primary rounded-lg w-full",
                              id: item.Code,
                              modelValue: item.Value,
                              "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                              placeholder: item.Description
                            }, null, 8, ["disabled", "id", "modelValue", "onUpdate:modelValue", "placeholder"])
                          ]))
                        : (item.Code == 'AuthReport')
                          ? (_openBlock(), _createBlock(_component_Multiselect, {
                              key: 3,
                              id: item.Code,
                              class: "mt-1 w-full rounded-lg",
                              modelValue: item.Value,
                              "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                              modelModifiers: { lazy: true },
                              mode: "tags",
                              searchable: true,
                              placeholder: item.Description,
                              options: item.OptionValue,
                              "allow-empty": false
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "placeholder", "options"]))
                          : (item.Code == 'PeriodeKomisiKurir')
                            ? (_openBlock(), _createBlock(_component_Multiselect, {
                                key: 4,
                                id: item.Code,
                                class: "mt-1 w-full rounded-lg can-not-empty input-primary",
                                modelValue: item.Value,
                                "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                                modelModifiers: { lazy: true },
                                searchable: true,
                                placeholder: item.Description,
                                options: item.OptionValue,
                                "allow-empty": false
                              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "placeholder", "options"]))
                            : (item.Code == 'BatasOrderCustomer')
                              ? (_openBlock(), _createBlock(_component_Dropdown, {
                                  key: 5,
                                  id: item.Code,
                                  disabled: !$setup.route.meta.permission.write,
                                  placeholder: "Pilih ",
                                  modelValue: item.Value,
                                  "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                                  class: "w-full mt-1 input-primary rounded-lg",
                                  options: $setup.OptionBatasOrderCustomer,
                                  optionLabel: "name",
                                  optionValue: "id"
                                }, null, 8, ["id", "disabled", "modelValue", "onUpdate:modelValue", "options"]))
                              : (item.Code == 'CancelKurir')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                                    _createVNode("div", _hoisted_17, [
                                      _createVNode(_component_RadioButton, {
                                        id: `${item.Code}a`,
                                        disabled: !$setup.route.meta.permission.write,
                                        name: item.Code,
                                        value: 'True',
                                        modelValue: item.Value,
                                        "onUpdate:modelValue": ($event: any) => (item.Value = $event)
                                      }, null, 8, ["id", "disabled", "name", "modelValue", "onUpdate:modelValue"]),
                                      _createVNode("label", {
                                        for: `${item.Code}a`
                                      }, "Ya", 8, ["for"])
                                    ]),
                                    _createVNode("div", _hoisted_18, [
                                      _createVNode(_component_RadioButton, {
                                        id: `${item.Code}b`,
                                        disabled: !$setup.route.meta.permission.write,
                                        name: item.Code,
                                        value: 'False',
                                        modelValue: item.Value,
                                        "onUpdate:modelValue": ($event: any) => (item.Value = $event)
                                      }, null, 8, ["id", "disabled", "name", "modelValue", "onUpdate:modelValue"]),
                                      _createVNode("label", {
                                        for: `${item.Code}b`
                                      }, "Tidak", 8, ["for"])
                                    ])
                                  ], 64))
                                : (item.Code == 'Banner1')
                                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                                      ($setup.imgTemp !== null && $setup.imgTemp !== 'null')
                                        ? (_openBlock(), _createBlock("div", _hoisted_20, [
                                            _createVNode("div", _hoisted_21, [
                                              ($setup.imgTemp !== null)
                                                ? (_openBlock(), _createBlock("div", {
                                                    key: 0,
                                                    class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                                    style: {"right":"0","top":"0","z-index":"10"},
                                                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.imgTemp = null))
                                                  }, [
                                                    _hoisted_22
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createVNode("div", $setup.getRootProps(), [
                                                _createVNode("input", $setup.getInputProps(), null, 16),
                                                _createVNode("img", {
                                                  class: "rounded-lg w-full cursor-pointer",
                                                  src: `${$setup.linkEnv}${$setup.imgTemp}`,
                                                  alt: `${$setup.linkEnv}${$setup.imgTemp}`
                                                }, null, 8, ["src", "alt"])
                                              ], 16)
                                            ]),
                                            _createVNode("div", _hoisted_23, [
                                              _createVNode("div", _hoisted_24, [
                                                _createVNode("p", _hoisted_25, _toDisplayString($setup.imgTemp), 1)
                                              ])
                                            ])
                                          ]))
                                        : ($setup.imgTemp === null  && $setup.imgTemp === 'null' || $setup.image.src === null)
                                          ? (_openBlock(), _createBlock("div", _hoisted_26, [
                                              _createVNode("div", _hoisted_27, [
                                                _createVNode("div", $setup.getRootProps(), [
                                                  _createVNode("input", $setup.getInputProps(), null, 16),
                                                  _hoisted_28
                                                ], 16)
                                              ])
                                            ]))
                                          : (_openBlock(), _createBlock("div", _hoisted_29, [
                                              _createVNode("div", _hoisted_30, [
                                                ($setup.image.src !== null)
                                                  ? (_openBlock(), _createBlock("div", {
                                                      key: 0,
                                                      class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                                      style: {"right":"0","top":"0","z-index":"10"},
                                                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.resetImage()))
                                                    }, [
                                                      _hoisted_31
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createVNode("div", $setup.getRootProps(), [
                                                  _createVNode("input", $setup.getInputProps(), null, 16),
                                                  _createVNode("img", {
                                                    class: "rounded-lg w-full cursor-pointer",
                                                    src: $setup.image.src,
                                                    alt: $setup.image.image.name
                                                  }, null, 8, ["src", "alt"])
                                                ], 16)
                                              ]),
                                              _createVNode("div", _hoisted_32, [
                                                _createVNode("div", _hoisted_33, [
                                                  _createVNode("p", _hoisted_34, _toDisplayString($setup.image.image.name), 1)
                                                ])
                                              ])
                                            ]))
                                    ]))
                                  : (_openBlock(), _createBlock(_component_InputText, {
                                      key: 8,
                                      id: item.Code,
                                      disabled: !$setup.route.meta.permission.write,
                                      placeholder: item.Description,
                                      modelValue: item.Value,
                                      "onUpdate:modelValue": ($event: any) => (item.Value = $event),
                                      class: "w-full mt-1 input-primary rounded-lg"
                                    }, null, 8, ["id", "disabled", "placeholder", "modelValue", "onUpdate:modelValue"]))
                ]))
              }), 128))
            ])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_35, [
          ($setup.route.meta.permission.update)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Simpan Perubahan",
                class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.submitData()))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}